"use client";

import { usePathname } from "next/navigation";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { FileProvider } from "@/lib/pdf-editor/FileContext";
import { stripLocaleFromPathname } from "@/lib/i18n";
import { WhatsAppButton } from "@/components/layout/WhatsAppButton";

export function ClientLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const normalizedPath = stripLocaleFromPathname(pathname || "/");
  const isEditorPage =
    normalizedPath?.startsWith('/edit-pdf') ||
    normalizedPath?.startsWith('/document/create') ||
    normalizedPath?.startsWith('/pdf-editor/');

  return (
    <FileProvider>
      {!isEditorPage && <Navbar />}
      <main className="flex-1">
        {children}
      </main>
      {!isEditorPage && <WhatsAppButton />}
      {!isEditorPage && <Footer />}
    </FileProvider>
  );
}
